import React, { useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';

import Body from '../Components/layout/Body';

const NAMES_HELP = `
<div>
  <p>The names you enter here are the ones that Access Navigator will display throughout the app. </p>
  <p>In particular, the client's first name is used frequently to try to make our instructions more personal and more clear.</p>
  <p>At some point, we plan to also offer the opportunity to choose preferred pronouns.  For now, though, it just defaults to they / them.</p>
</div>
`;

//content sub-component with unique content for this page
function GetStartedNamesContent(props) {
  const {
    providerName,
    onChangeProviderName,
    clientName,
    onChangeClientName,
  } = props;
  return(
    <>
    <Form>
      <FormGroup>
        <Label for="provider-name" className="aa-bold-text">
          Your first name:
        </Label>
        <Input
          id="provider-name"
          value={providerName || ''}
          onChange={onChangeProviderName}
          name="provider-name"
          type="textfield"
        />
      </FormGroup>
      <FormGroup>
        <Label for="client-name" className="aa-bold-text">
          The client's first name:
        </Label>
        <Input
          id="client-name"
          value={clientName}
          onChange={onChangeClientName}
          name="client-name"
          type="textfield"
        />
      </FormGroup>
    </Form>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GetStartedNames(props) {
  const {
    providerName,
    onChangeProviderName,
    clientName,
    onChangeClientName,
    saveFormData,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users", //include this font-awesome icon in the image column of the page
    title: "Please enter names for you and your client",
    subTitle: "That's all we need to get started!",
    learnMore: {linkText: "Learn More about why we ask for these names",
                title: "Why we ask for these names",
                content: NAMES_HELP
                },
    nextRoute: '', //EVAL_INTRO, //static name for next page since this never changes
    sidebar: false
  }

  console.log("rendering GetStartedNames");

  useEffect(() => {
    console.log('GetStartedNames mounted');
    return () => {
      console.log('GSN unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <GetStartedNamesContent 
          providerName={providerName} 
          onChangeProviderName={onChangeProviderName}
          clientName={clientName}
          onChangeClientName={onChangeClientName}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default GetStartedNames;